function changeProductMainThumbnail(image) {
  const mainThumbnail = document.getElementById('product-thumbnail');
  let imageURL = image.getAttribute('data-image');
  let imageALT = image.getAttribute('data-alt');
  mainThumbnail.setAttribute('src', imageURL);
  mainThumbnail.setAttribute('alt', imageALT);
  document
    .querySelectorAll('.product-gallery__thumbnails__thumbnail')
    .forEach(function (thumbnail) {
      thumbnail.classList.remove('active');
    });
  image.classList.add('active');
}

function updateSelectedThumbnail(formatSelect) {
  let format = document.querySelector(
    '.product-gallery__thumbnails__format[data-size="' +
      formatSelect.value +
      '"]'
  );
  if (format) {
    let thumbnail = format.querySelector(
      '.product-gallery__thumbnails__thumbnail'
    );
    changeProductMainThumbnail(thumbnail);
  }
}

window.addEventListener('DOMContentLoaded', function () {
  const galleryThumbnails = document.querySelectorAll(
    '.product-gallery__thumbnails__thumbnail'
  );
  const formatSelect = document.getElementById('product_sizes');
  const nutritionTabBtn = document.querySelector('.tab-nutrition');

  if (0 < galleryThumbnails.length) {
    changeProductMainThumbnail(galleryThumbnails[0]);

    galleryThumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        changeProductMainThumbnail(thumbnail);
      });
    });
  }

  if (formatSelect) {
    updateSelectedThumbnail(formatSelect);

    const product_url = formatSelect.dataset.product_url;

    formatSelect.addEventListener('change', function () {
      updateSelectedThumbnail(this);

      if (this.value) {
        const url =
          'none' === this.value ? product_url : product_url + this.value + '/';
        window.history.pushState('', '', url);
      }
    });
  }

  if (nutritionTabBtn) {
    nutritionTabBtn.addEventListener('click', function () {
      let selectedFormat = formatSelect.value;
      let format_thumbnail;
      let thumbnail;
      let format = document.querySelector(
        '.product-gallery__thumbnails__format[data-size="' +
          selectedFormat +
          '"]'
      );
      thumbnail = document.querySelector(
        '.product-gallery__thumbnails__thumbnail.thumbnail-nutrition'
      );
      if (format) {
        format_thumbnail = format.querySelector(
          '.product-gallery__thumbnails__thumbnail.thumbnail-nutrition'
        );
      }
      if (format_thumbnail) {
        thumbnail = format_thumbnail;
      }
      if (thumbnail) {
        changeProductMainThumbnail(thumbnail);
        window.scrollTo({ top: 0 });
      }
    });
  }
});
